import { useState } from 'react';
import NarrativeModal from './NarrativeModal';
import ModuleEmptyState from '../dashboard/ModuleEmptyState';
import styles from './DashboardModules.module.css';

const NarrativeModule = ({
  digitalLegacy,
  isComplete,
  isRecommended,
  onSave,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className={`${styles.moduleCard} ${isComplete ? styles.completed : ''} ${isRecommended ? styles.recommended : ''}`}
      >
        <div className={styles.moduleHeader}>
          <h5>Narrative & Experience</h5>
          {isComplete ? (
            <span className={`${styles.statusTag} ${styles.complete}`}>
              Complete
            </span>
          ) : (
            <span className={`${styles.statusTag} ${styles.todo}`}>To-Do</span>
          )}
        </div>
        <div className={styles.moduleContent}>
          {isComplete ? (
            <>
              <p className={styles.moduleDescription}>
                Your persona's backstory, goals, and professional history have
                been defined.
              </p>
              <button
                onClick={() => setIsModalOpen(true)}
                className={`action-button secondary ${styles.editButton}`}
              >
                Edit Narrative
              </button>
            </>
          ) : (
            <ModuleEmptyState
              icon="fa-feather-alt"
              text="Flesh out your persona's story and background to give it a richer, more detailed identity."
              buttonText="Add Narrative"
              onButtonClick={() => setIsModalOpen(true)}
            />
          )}
        </div>
      </div>
      {isModalOpen && (
        <NarrativeModal
          digitalLegacy={digitalLegacy}
          onClose={() => setIsModalOpen(false)}
          onSave={onSave}
        />
      )}
    </>
  );
};

export default NarrativeModule;
